


































































import Vue from 'vue';
import {Component, Watch} from 'vue-property-decorator';
import {Location} from 'vue-router';
import LogoutBtn from '@/screens/dashboard/components/LogoutBtn.vue';
import ShopSelect from '@/screens/management/ShopSelect.vue';
import {ModuleShop} from '@/store/modules/ShopModule';
import OrganizationSelect from '@/screens/management/OrganizationSelect.vue';
import {ModuleOrganization} from '@/store/modules/OrganizationModule';

interface ITabItem {
  route: Location;
  text: string;
  icon: string;
}

@Component({
  components: {
    LogoutBtn,
    ShopSelect,
    OrganizationSelect
  }
})
export default class Dashboard extends Vue {
  private drawer = true;
  private loading: boolean = true;
  private shopCurId: number = 0;
  private organizationCurId: number = 0;

  protected mounted() {
    this.loadData().then();
  }

  get shopId() {
    return ModuleShop.shopId;
  }

  get organizationId() {
    return ModuleOrganization.organizationId;
  }

  @Watch('organizationId', {immediate: true})

  @Watch('shopId', {immediate: true})
  async loadData() {
    try {
      this.loading = true;
      this.shopCurId = this.shopId;
      this.organizationCurId = this.organizationId;
    } finally {
      this.loading = false;
    }
  }

  get items(): ITabItem[] {
    return [
      {
        route: {name: 'dashboard.overview'},
        text: 'Dashboard',
        icon: 'fa-tachometer-alt',
      },
      {
        route: {name: 'dashboard.products'},
        text: 'Products',
        icon: 'fa-box',
      },
      {
        route: {name: 'dashboard.suppliers'},
        text: 'Suppliers',
        icon: 'fa-parachute-box',
      },
      {
        route: {name: 'dashboard.order'},
        text: 'Orders',
        icon: 'fa-file-invoice',
      },
      {
        route: {name: 'dashboard.tracking'},
        text: 'Trackings',
        icon: 'fa-truck',
      },
      {
        route: {name: 'dashboard.fulfillment'},
        text: 'Fulfillments',
        icon: 'fa-tasks',
      },
      {
        route: {name: 'dashboard.facebook-pixel-management'},
        text: 'Facebook Pixel Manager',
        icon: 'fab fa-facebook-square'
      },
      {
        route: {name: 'dashboard.event-management'},
        text: 'Event Manager',
        icon: 'fas fa-ad'
      }
    ];
  }
}
